import { render, staticRenderFns } from "./pointsconfig.vue?vue&type=template&id=15be2b26&scoped=true"
import script from "./pointsconfig.vue?vue&type=script&lang=js"
export * from "./pointsconfig.vue?vue&type=script&lang=js"
import style0 from "./pointsconfig.vue?vue&type=style&index=0&id=15be2b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be2b26",
  null
  
)

export default component.exports